import { render, staticRenderFns } from "./TheEmptyRouterView.vue?vue&type=template&id=bcd0f69e"
import script from "./TheEmptyRouterView.vue?vue&type=script&lang=js"
export * from "./TheEmptyRouterView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports